import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const STATES = [
    'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
    'Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh',
    'Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab',
    'Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh',
    'Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu','Delhi',
    'Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'
];
const CLASSES      = ['6th','7th','8th','9th','10th','11th','12th','Undergraduate','Graduate','Post-Graduate','Other'];
const GENDERS      = ['Male','Female','Transgender','Prefer not to say'];
const SOCIAL_GRP   = ['General','OBC','SC','ST','EWS','Other'];
const ORG_TYPES    = ['School','College','University','Coaching Institute','Other'];
const SCHOOL_TYPES = ['Government School','Government Aided School','Private School','Central Government School (KV/NV/AINST)','Other'];
const HOW_OPTIONS  = ['Advertisement','School','Friends','Internet','College','Library','Social Media','Other'];

const EMPTY = {
    student_name:'', father_name:'', dob:'', email:'', country:'India',
    state:'', district:'', city_village:'', social_group:'',
    mobile_number:'', gender:'', org_type:'School', school_type:'',
    class:'', school_name:'', preparing_for:'',
    how_to_know:[], agree_terms:false, kendra_id:''
};

/* ── styling atoms ─────────────────────────────────────────── */
const IS = {
    width:'100%', padding:'10px 13px', border:'1.5px solid #d1d5db',
    borderRadius:10, fontSize:14, outline:'none',
    boxSizing:'border-box', background:'#fff', transition:'border-color .18s',
};
const fo = e => { e.currentTarget.style.borderColor='#667eea'; };
const bl = e => { e.currentTarget.style.borderColor='#d1d5db'; };

const FG = ({ label, required, hint, children }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
        <label style={{ fontSize:13, fontWeight:600, color:'#374151' }}>
            {label}{required && <span style={{ color:'#ef4444' }}> *</span>}
        </label>
        {children}
        {hint && <p style={{ margin:0, fontSize:11, color:'#9ca3af', lineHeight:1.4 }}>{hint}</p>}
    </div>
);

const TInput = (props) => <input {...props} style={IS} onFocus={fo} onBlur={bl} />;
const TSel   = ({ options, placeholder, ...p }) => (
    <select {...p} style={{ ...IS, color:p.value?'#111':'#9ca3af' }} onFocus={fo} onBlur={bl}>
        <option value="">{placeholder||'Select'}</option>
        {options.map(o=><option key={o} value={o}>{o}</option>)}
    </select>
);
const SecHead = ({ icon, title }) => (
    <div style={{ display:'flex', alignItems:'center', gap:8,
        margin:'22px 0 14px', paddingBottom:9, borderBottom:'2px solid #f0f4ff' }}>
        <i className={`bx ${icon}`} style={{ fontSize:18, color:'#667eea' }}/>
        <span style={{ fontSize:12, fontWeight:800, color:'#4a5568',
            textTransform:'uppercase', letterSpacing:.7 }}>{title}</span>
    </div>
);
const Grid2 = ({ children }) => (
    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(210px,1fr))', gap:14 }}>
        {children}
    </div>
);
const Td = ({ children, s={} }) => (
    <td style={{ padding:'9px 11px', color:'#374151', verticalAlign:'middle', ...s }}>{children}</td>
);
const AB = ({ col, ic, lbl, onClick }) => (
    <button onClick={onClick}
        style={{ display:'inline-flex', alignItems:'center', gap:4, padding:'5px 11px',
            background:col, color:'#fff', border:'none', borderRadius:8,
            fontSize:12, fontWeight:600, cursor:'pointer' }}
        onMouseEnter={e=>{e.currentTarget.style.opacity='.8';}}
        onMouseLeave={e=>{e.currentTarget.style.opacity='1';}}>
        <i className={`bx ${ic}`}/>{lbl}
    </button>
);
const PB = ({ children, active, disabled, onClick }) => (
    <button onClick={onClick} disabled={disabled}
        style={{ padding:'5px 11px', border:'1.5px solid',
            borderColor:active?'#667eea':'#e5e7eb', borderRadius:8,
            background:active?'#667eea':'#fff',
            color:active?'#fff':disabled?'#d1d5db':'#374151',
            fontSize:13, fontWeight:600, cursor:disabled?'not-allowed':'pointer' }}>
        {children}
    </button>
);

/* ── main ───────────────────────────────────────────────────── */
const HclSatheeStudentRegistration = () => {
    const [form,      setForm]      = useState(EMPTY);
    const [loading,   setLoading]   = useState(false);
    const [students,  setStudents]  = useState([]);
    const [kendras,   setKendras]   = useState([]);
    const [search,    setSearch]    = useState('');
    const [customExam, setCustomExam] = useState('');
    const [editId,    setEditId]    = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [page,      setPage]      = useState(1);
    const [dlFilters, setDlFilters] = useState({ state:'', district:'', schoolName:'', studentClass:'' });
    const PER = 10;

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        try {
            const hdrs = { headers:{ Authorization:localStorage.getItem('token') } };
            const [kRes, sRes] = await Promise.all([
                Axios.get(`${API_URL}/sathee/kendra`, hdrs),
                Axios.get(`${API_URL}/sathee/student`, hdrs)
            ]);
            if (kRes.data.status==='success') setKendras(kRes.data.data);
            if (sRes.data.status==='success') setStudents(sRes.data.data);
        } catch(e){ console.error(e); }
    };

    const chg = e => { const{name,value}=e.target; setForm(p=>({...p,[name]:value})); };

    const toggleHow = v => setForm(p=>({
        ...p, how_to_know:p.how_to_know.includes(v)
            ? p.how_to_know.filter(x=>x!==v)
            : [...p.how_to_know,v]
    }));

    const submit = async e => {
        e.preventDefault();
        if (!form.kendra_id){ toast.error('Please assign a Kendra',{position:'top-center'}); return; }
        if (form.mobile_number && !/^[0-9]{10}$/.test(form.mobile_number)){
            toast.error('Mobile number must be 10 digits',{position:'top-center'}); return; }
        
        setLoading(true);
        try {
            const payload = {
                ...form
            };
            if (payload.preparing_for === 'Other' && customExam.trim()) {
                payload.preparing_for = customExam.trim();
            }
            const url = isEditing?`${API_URL}/sathee/student/${editId}`:`${API_URL}/sathee/student`;
            const fn  = isEditing ? Axios.put : Axios.post;
            const r   = await fn(url, payload, { headers:{ Authorization:localStorage.getItem('token') } });
            
            if (r.data.status==='success'){
                toast.success(r.data.message,{position:'top-center'});
                setForm(EMPTY); setIsEditing(false); setEditId(null); load();
            } else toast.error(r.data.message,{position:'top-center'});
        } catch(err){ toast.error(err.response?.data?.message||'Failed to save',{position:'top-center'}); }
        finally { setLoading(false); }
    };

    const edit = s => {
        const standardExams = ['JEE', 'NEET', 'CUET', 'Board Exam', 'SSC'];
        let preparingFor = s.preparing_for || '';
        let custom = '';
        if (preparingFor && !standardExams.includes(preparingFor)) {
            custom = preparingFor;
            preparingFor = 'Other';
        }
        setCustomExam(custom);
        
        setForm({
            student_name:s.student_name||'', father_name:s.father_name||'',
            dob:s.dob?s.dob.split('T')[0]:'', email:s.email||'',
            country:s.country||'India', state:s.state||'', district:s.district||'',
            city_village:s.city_village||'', social_group:s.social_group||'',
            mobile_number:s.mobile_number||'', gender:s.gender||'',
            org_type:s.org_type||'School', school_type:s.school_type||'',
            class:s.class||'', school_name:s.school_name||'',
            preparing_for:preparingFor,
            how_to_know:(() => {
                if(!s.how_to_know) return [];
                try { return typeof s.how_to_know === 'string' ? JSON.parse(s.how_to_know) : s.how_to_know; } 
                catch { return []; }
            })(),
            agree_terms:true,
            kendra_id: s.kendra_id||''
        });
        setEditId(s.id); setIsEditing(true);
        window.scrollTo({top:0,behavior:'smooth'});
    };

    const del = async id => {
        if (!window.confirm('Delete this student?')) return;
        try {
            const r = await Axios.delete(`${API_URL}/sathee/student/${id}`,
                { headers:{ Authorization:localStorage.getItem('token') } });
            if (r.data.status==='success'){ toast.success(r.data.message,{position:'top-center'}); load(); }
        } catch { toast.error('Delete failed',{position:'top-center'}); }
    };

    const dlExcel = async () => {
        // The user should use HclSatheeReports for Excel downloads now, 
        // but we can retain this simple shortcut for standard list download
        try {
            const qs = new URLSearchParams(dlFilters).toString();
            const r = await Axios.get(`${API_URL}/sathee/reports/download?${qs}`,
                { headers:{ Authorization:localStorage.getItem('token') }, responseType:'blob' });
            const u=window.URL.createObjectURL(new Blob([r.data]));
            const a=document.createElement('a'); a.href=u; a.download='HCL_Sathee_Students.xlsx';
            document.body.appendChild(a); a.click(); a.remove();
            toast.success('Downloaded!',{position:'top-center'});
        } catch { toast.error('Download failed',{position:'top-center'}); }
    };

    const filt = students.filter(s=>{
        const matchesSearch = [s.student_name,s.school_name,s.state,s.district,s.gender,s.class,s.mobile_number]
            .some(v=>v?.toString().toLowerCase().includes(search.toLowerCase()));
        const matchesState = !dlFilters.state || s.state === dlFilters.state;
        const matchesDist  = !dlFilters.district || (s.district||'').toLowerCase().includes(dlFilters.district.toLowerCase());
        const matchesSch   = !dlFilters.schoolName || (s.school_name||'').toLowerCase().includes(dlFilters.schoolName.toLowerCase());
        const matchesCls   = !dlFilters.studentClass || s.class === dlFilters.studentClass;
        return matchesSearch && matchesState && matchesDist && matchesSch && matchesCls;
    });
    const totP = Math.ceil(filt.length/PER);
    const rows = filt.slice((page-1)*PER, page*PER);

    return (
        <div style={{ maxWidth:860, margin:'0 auto', padding:'0 0 48px' }}>
            <ToastContainer/>

            {/* header */}
            <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:20, flexWrap:'wrap' }}>
                <div style={{ width:50, height:50, borderRadius:14,
                    background:'linear-gradient(135deg,#667eea,#764ba2)',
                    display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="bx bxs-graduation" style={{ fontSize:26, color:'#fff' }}/>
                </div>
                <div>
                    <h1 style={{ margin:0, fontSize:20, fontWeight:800, color:'#1a202c' }}>
                        {isEditing?'✏️ Edit Student':'🎓 Student HCL Sathee Registration'}
                    </h1>
                    <p style={{ margin:0, fontSize:12, color:'#718096' }}>
                        Register students for HCL SATHEE program
                    </p>
                </div>
            </div>

            {/* FORM CARD */}
            <div style={{ background:'#fff', borderRadius:20,
                boxShadow:'0 4px 30px rgba(0,0,0,0.10)', overflow:'hidden', marginBottom:28 }}>
                <div style={{
                    background:isEditing?'linear-gradient(135deg,#f59e0b,#d97706)':'linear-gradient(135deg,#667eea,#764ba2)',
                    padding:'13px 22px', display:'flex', alignItems:'center', gap:10 }}>
                    <i className={`bx ${isEditing?'bx-edit':'bx-user-plus'}`} style={{ fontSize:19, color:'#fff' }}/>
                    <span style={{ fontSize:15, fontWeight:700, color:'#fff' }}>
                        {isEditing?'Edit Registration':'New Student Registration'}
                    </span>
                    <span style={{ marginLeft:'auto', background:'rgba(255,255,255,.2)', color:'#fff',
                        borderRadius:20, padding:'2px 10px', fontSize:12 }}>{students.length} Registered</span>
                </div>

                <form onSubmit={submit} style={{ padding:'20px 24px' }}>

                    {/* PERSONAL */}
                    <SecHead icon="bx-user" title="Personal Information"/>
                    <Grid2>
                        <FG label="Name" required>
                            <TInput name="student_name" value={form.student_name} onChange={chg}
                                placeholder="Enter student name" required autoComplete="off"/>
                        </FG>
                        <FG label="Father's Name" required>
                            <TInput name="father_name" value={form.father_name} onChange={chg}
                                placeholder="Enter father's name" required autoComplete="off"/>
                        </FG>
                        <FG label="Date of Birth" required>
                            <TInput name="dob" type="date" value={form.dob} onChange={chg} required
                                max={new Date().toISOString().split('T')[0]}/>
                        </FG>
                        <FG label="Email Id" required>
                            <TInput name="email" type="email" value={form.email} onChange={chg}
                                placeholder="Enter student email address" required autoComplete="off"/>
                        </FG>
                        <FG label="Gender" required>
                            <TSel name="gender" value={form.gender} onChange={chg}
                                options={GENDERS} placeholder="Select Gender" required/>
                        </FG>
                        <FG label="Social Group" required>
                            <TSel name="social_group" value={form.social_group} onChange={chg}
                                options={SOCIAL_GRP} placeholder="Select Social Group" required/>
                        </FG>
                        <FG label="Mobile Number" hint="Preferably WhatsApp — optional">
                            <TInput name="mobile_number" type="tel" value={form.mobile_number} onChange={chg}
                                placeholder="Preferably WhatsApp" maxLength={10}
                                onInput={e=>{e.target.value=e.target.value.replace(/\D/g,'');}}/>
                        </FG>
                    </Grid2>

                    {/* LOCATION & KENDRA */}
                    <SecHead icon="bx-map" title="Location & Kendra Assignment"/>
                    <Grid2>
                        <FG label="Country" required>
                            <TSel name="country" value={form.country} onChange={chg}
                                options={['India']} required/>
                        </FG>
                        <FG label="State" required>
                            <TSel name="state" value={form.state} onChange={chg}
                                options={STATES} placeholder="Select State" required/>
                        </FG>
                        <FG label="District" required>
                            <TInput name="district" value={form.district} onChange={chg}
                                placeholder="Enter district" required autoComplete="off"/>
                        </FG>
                        <FG label="City / Village" required>
                            <TInput name="city_village" value={form.city_village} onChange={chg}
                                placeholder="Enter city or village name" required autoComplete="off"/>
                        </FG>
                        <FG label="Assign to Kendra" required hint="Mandatory for HCL Sathee students">
                            <select name="kendra_id" value={form.kendra_id} onChange={chg} required style={{...IS, borderColor:'#3b82f6'}}>
                                <option value="">Select a Kendra</option>
                                {kendras.map(k => <option key={k.id} value={k.id}>{k.kendra_name}</option>)}
                            </select>
                        </FG>
                    </Grid2>

                    {/* SCHOOL */}
                    <SecHead icon="bxs-school" title="School & Course"/>
                    <div style={{ marginBottom:14 }}>
                        <FG label="Organization Type" required>
                            <TSel name="org_type" value={form.org_type} onChange={chg}
                                options={ORG_TYPES} required/>
                        </FG>
                    </div>
                    <Grid2>
                        <FG label="School Type" required>
                            <TSel name="school_type" value={form.school_type} onChange={chg}
                                options={SCHOOL_TYPES} placeholder="Select School Type" required/>
                        </FG>
                        <FG label="Class" required>
                            <TSel name="class" value={form.class} onChange={chg}
                                options={CLASSES} placeholder="Select Class" required/>
                        </FG>
                    </Grid2>
                    <div style={{ marginTop:14 }}>
                        <p style={{ margin:'0 0 5px', fontSize:12, color:'#9ca3af', fontStyle:'italic' }}>
                            * Select 'Others' if your school name is not listed below
                        </p>
                        <FG label="School Name" required>
                            <TInput name="school_name" value={form.school_name} onChange={chg}
                                placeholder="Enter school name" required autoComplete="off"/>
                        </FG>
                    </div>
                    <div style={{ marginTop:14 }}>
                        <Grid2>
                            <FG label="Preparing For Exam" required>
                                <TSel name="preparing_for" value={form.preparing_for} onChange={chg}
                                    options={['JEE', 'NEET', 'CUET', 'Board Exam', 'SSC', 'Other']} placeholder="Select Exam" required/>
                            </FG>
                            {form.preparing_for === 'Other' && (
                                <FG label="Specify Other Exam" required>
                                    <TInput name="customExam" value={customExam} onChange={e => setCustomExam(e.target.value)}
                                        placeholder="Enter exam name" required autoComplete="off"/>
                                </FG>
                            )}
                        </Grid2>
                    </div>


                    {/* BUTTONS */}
                    <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
                        <button type="submit" disabled={loading} style={{
                            flex:1, minWidth:160, padding:'13px 24px',
                            border:'none', borderRadius:12,
                            background:isEditing
                                ?'linear-gradient(135deg,#f59e0b,#d97706)'
                                :'linear-gradient(135deg,#667eea,#764ba2)',
                            color:'#fff', fontSize:15, fontWeight:700,
                            cursor:loading?'not-allowed':'pointer',
                            boxShadow:'0 4px 14px rgba(102,126,234,.4)',
                            transition:'all .2s', opacity:loading?.7:1 }}
                            onMouseEnter={e=>{if(!loading)e.currentTarget.style.transform='translateY(-2px)';}}
                            onMouseLeave={e=>{e.currentTarget.style.transform='none';}}>
                            {loading
                                ? <><i className="bx bx-loader-circle bx-spin" style={{ marginRight:6 }}/>{isEditing?'Updating…':'Registering…'}</>
                                : isEditing ? '💾 Update Student' : '✅ Submit'}
                        </button>
                        {isEditing && (
                            <button type="button"
                                onClick={()=>{setForm(EMPTY);setIsEditing(false);setEditId(null);setCustomExam('');}}
                                style={{ flex:1, minWidth:130, padding:'13px 24px',
                                    border:'2px solid #e5e7eb', borderRadius:12,
                                    background:'#fff', color:'#6b7280',
                                    fontSize:15, fontWeight:700, cursor:'pointer' }}>
                                ✕ Cancel
                            </button>
                        )}
                        <button type="button"
                            onClick={()=>{setForm(EMPTY);setIsEditing(false);setEditId(null);setCustomExam('');}}
                            style={{ padding:'13px 18px', border:'2px solid #e5e7eb',
                                borderRadius:12, background:'#fff',
                                color:'#9ca3af', fontSize:14, cursor:'pointer' }}>
                            <i className="bx bx-reset"/> Clear
                        </button>
                    </div>
                </form>
            </div>

            {/* STUDENTS TABLE */}
            <div style={{ background:'#fff', borderRadius:20,
                boxShadow:'0 4px 24px rgba(0,0,0,.08)', overflow:'hidden' }}>
                <div style={{ padding:'13px 20px', borderBottom:'1px solid #f3f4f6',
                    display:'flex', alignItems:'center', justifyContent:'space-between',
                    flexWrap:'wrap', gap:10 }}>
                    <h2 style={{ margin:0, fontSize:15, fontWeight:800, color:'#1a202c' }}>
                        📋 Registered Students{' '}
                        <span style={{ background:'#667eea', color:'#fff',
                            borderRadius:20, padding:'2px 10px', fontSize:12 }}>
                            {students.length}
                        </span>
                    </h2>
                    <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
                        <div style={{ position:'relative' }}>
                            <i className="bx bx-search" style={{ position:'absolute', left:9,
                                top:'50%', transform:'translateY(-50%)', color:'#9ca3af' }}/>
                            <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}
                                placeholder="Search…"
                                style={{ padding:'8px 12px 8px 30px', border:'1.5px solid #e5e7eb',
                                    borderRadius:10, fontSize:13, width:190, outline:'none' }}/>
                        </div>
                        <button onClick={dlExcel} style={{
                            display:'flex', alignItems:'center', gap:6, padding:'8px 15px',
                            background:'linear-gradient(135deg,#10b981,#059669)',
                            color:'#fff', border:'none', borderRadius:10,
                            fontSize:13, fontWeight:600, cursor:'pointer' }}>
                            <i className="bx bx-download"/> Excel
                        </button>
                    </div>
                </div>

                <div style={{ padding:'12px 20px', background:'#f8fafc', borderBottom:'1px solid #e5e7eb', display:'flex', gap:10, flexWrap:'wrap', alignItems:'center' }}>
                    <span style={{ fontSize:12, fontWeight:600, color:'#64748b' }}><i className="bx bx-filter-alt"/> FILTERS:</span>
                    <select value={dlFilters.state} onChange={e=>setDlFilters(p=>({...p,state:e.target.value}))} style={{ padding:'6px 10px', fontSize:12, borderRadius:6, border:'1px solid #cbd5e1', outline:'none' }}>
                        <option value="">All States</option>
                        {STATES.map(s=><option key={s} value={s}>{s}</option>)}
                    </select>
                    <input type="text" placeholder="District" value={dlFilters.district} onChange={e=>setDlFilters(p=>({...p,district:e.target.value}))} style={{ padding:'6px 10px', fontSize:12, borderRadius:6, border:'1px solid #cbd5e1', width:120, outline:'none' }} />
                    <input type="text" placeholder="School Name" value={dlFilters.schoolName} onChange={e=>setDlFilters(p=>({...p,schoolName:e.target.value}))} style={{ padding:'6px 10px', fontSize:12, borderRadius:6, border:'1px solid #cbd5e1', width:150, outline:'none' }} />
                    <select value={dlFilters.studentClass} onChange={e=>setDlFilters(p=>({...p,studentClass:e.target.value}))} style={{ padding:'6px 10px', fontSize:12, borderRadius:6, border:'1px solid #cbd5e1', outline:'none' }}>
                        <option value="">All Classes</option>
                        {CLASSES.map(c=><option key={c} value={c}>{c}</option>)}
                    </select>
                </div>

                <div style={{ overflowX:'auto' }}>
                    {rows.length>0 ? (
                        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                            <thead>
                                <tr style={{ background:'#f8fafc' }}>
                                    {['#','Name','Father','Kendra','Class','School','State','District','Mobile','Actions'].map(h=>(
                                        <th key={h} style={{ padding:'10px 11px', textAlign:'left', fontWeight:700,
                                            color:'#6b7280', fontSize:11, textTransform:'uppercase',
                                            letterSpacing:.4, borderBottom:'2px solid #f3f4f6', whiteSpace:'nowrap' }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((s,i)=>(
                                    <tr key={s.id}
                                        style={{ borderBottom:'1px solid #f3f4f6',
                                            background:i%2===0?'#fff':'#fafafa',
                                            transition:'background .12s' }}
                                        onMouseEnter={e=>{e.currentTarget.style.background='#f0f4ff';}}
                                        onMouseLeave={e=>{e.currentTarget.style.background=i%2===0?'#fff':'#fafafa';}}>
                                        <Td>{(page-1)*PER+i+1}</Td>
                                        <Td><b>{s.student_name}</b></Td>
                                        <Td>{s.father_name||'—'}</Td>
                                        <Td>{s.kendra_name||'—'}</Td>
                                        <Td>{s.class||'—'}</Td>
                                        <Td s={{ maxWidth:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.school_name}</Td>
                                        <Td>{s.state||'—'}</Td>
                                        <Td>{s.district||'—'}</Td>
                                        <Td>{s.mobile_number||'—'}</Td>
                                        <td style={{ padding:'8px 11px', whiteSpace:'nowrap' }}>
                                            <div style={{ display:'flex', gap:5 }}>
                                                <AB col="#3b82f6" ic="bx-edit"  lbl="Edit"   onClick={()=>edit(s)}/>
                                                <AB col="#ef4444" ic="bx-trash" lbl="Delete" onClick={()=>del(s.id)}/>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div style={{ textAlign:'center', padding:'48px 20px', color:'#9ca3af' }}>
                            <i className="bx bx-user-x" style={{ fontSize:48 }}/>
                            <p style={{ marginTop:10 }}>
                                {search?'No students match your search':'No students registered yet'}
                            </p>
                        </div>
                    )}
                </div>

                {totP>1 && (
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center',
                        padding:'11px 20px', borderTop:'1px solid #f3f4f6', flexWrap:'wrap', gap:8 }}>
                        <span style={{ fontSize:13, color:'#6b7280' }}>
                            Showing {(page-1)*PER+1}–{Math.min(page*PER,filt.length)} of {filt.length}
                        </span>
                        <div style={{ display:'flex', gap:5, flexWrap:'wrap', paddingRight:'60px' }}>
                            <PB disabled={page===1} onClick={()=>setPage(p=>p-1)}>‹</PB>
                            {(() => {
                                let startP = Math.max(1, page - 2);
                                let endP = Math.min(totP, page + 2);
                                if (endP - startP < 4) {
                                    if (startP === 1) endP = Math.min(totP, 5);
                                    else if (endP === totP) startP = Math.max(1, totP - 4);
                                }
                                const pages = [];
                                if (startP > 1) { pages.push(1); if (startP > 2) pages.push('...'); }
                                for (let i = startP; i <= endP; i++) pages.push(i);
                                if (endP < totP) { if (endP < totP - 1) pages.push('...'); pages.push(totP); }
                                
                                return pages.map((p, idx) => (
                                    <PB 
                                        key={idx} 
                                        active={page===p} 
                                        disabled={p==='...'} 
                                        onClick={()=> p !== '...' && setPage(p)} 
                                        style={p==='...' ? {background:'transparent', color:'#6b7280', border:'none', cursor:'default', padding:'5px 2px'} : {}}
                                    >
                                        {p}
                                    </PB>
                                ));
                            })()}
                            <PB disabled={page===totP} onClick={()=>setPage(p=>p+1)}>›</PB>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HclSatheeStudentRegistration;
